import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Link from 'next/link';

function AlertBell({ alertList }) {
  const numberOfAlerts = alertList.total;

  if (!numberOfAlerts) return <></>;

  const badgeColor = _.get(alertList, 'entities[0].color');

  return (
    <Link legacyBehavior href="/app/alerts?query[isClosed]=false" passHref>
      <div className="px-2" style={{ cursor: 'pointer' }}>
        <span
          className="dripicons-bell text-muted ring-bell"
          style={{ fontSize: '1.2rem' }}
        />
        <div className={`alert-badge bg-${badgeColor}`}>{numberOfAlerts}</div>
      </div>
    </Link>
  );
}

AlertBell.propTypes = {
  alertList: PropTypes.object.isRequired,
};

const mapStateToProps = ({ alertList }) => ({
  alertList,
});

export default connect(mapStateToProps)(AlertBell);
